import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {
    fetchClaimColleagues,
    fetchClaimHistory,
    fetchTravelClaimFiles,
    retrieveTravelClaim
} from '../services/travelClaims';

export const useTravelClaimQuery = (pk:string) => {
    return useQuery({
        queryKey: ['travelClaim', pk],
        queryFn: () => retrieveTravelClaim(pk),
        refetchOnWindowFocus: false,
    });
};

export const useTravelClaimFilesQuery = (claim_pk: string | undefined) => {
    if (!claim_pk) {
        throw Error("Отсутствует идентификатор заявки");
    }

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ["travelClaimFiles", claim_pk],
        queryFn: () => fetchTravelClaimFiles(claim_pk),
    });
}

export const useClaimColleaguesQuery = (search: string | undefined, claim_pk: string) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['claimColleagues'],
        queryFn: (
            {
                pageParam = {
                    limit: limit,
                    offset: 0
                }
            }
        ) => fetchClaimColleagues(claim_pk, pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}

export const useClaimHistoryQuery = (pk: string) => {
    const limit = 5;
    return useInfiniteQuery({
        queryKey: ['claimHistory'],
        queryFn: ({pageParam = {limit: limit, offset: 0}}) => fetchClaimHistory(pk, pageParam.limit, pageParam.offset),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}